import { createVanIconComponent } from "./van"

const Live = createVanIconComponent("live")
export default Live
